import { render } from "./EnvironmentBanner.vue?vue&type=template&id=2e1f8858"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashboard.lims.ninja/dashboard.lims.ninja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__